import * as R from 'ramda'
import { of } from 'rxjs'
import { delayWhen, distinctUntilChanged, filter, ignoreElements, map, tap } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import { LOCATION_CHANGE } from 'connected-react-router'
import { queryFromString } from 'helpers/url'
import { track } from 'tracking/mixPanel'
import * as Actions from 'store/actions/index.ts'
import { MIXPANEL_ACCESS_MAP } from 'constants/mixpanel'
import { isProductPageAction } from 'domain/router'
import { isProductFetched } from 'domain/resources'
import {
  getCurrentProduct,
  getCurrentProductLabelsFormattedForTracking,
  getCurrentResourceSubUniverseName,
  getCurrentResourceUniverseName,
  getDaysSinceStartSale,
  getFilteredViewedProducts,
  getFrom,
  getHasCrossSaleOnLastViewedProducts,
  getIsSaleFetched,
  getIsViewedProductsFetched,
  getNbSubUniversesInCatalog,
  getNbUniversesInCatalog,
  getOperationCode,
  getProductCallPrice,
  getProductPriceValue,
  getSaleStartTime,
  getTypeOfAccess
} from 'store/selectors'
import {
  awaitForProductFetched
} from 'store/epics/helpers'
import { isSamePage } from '../../helpers/router'
import { disableMixPanelTracking } from '../disable'

export const getViewProductPageData = (state) => {
  const nbUniverses = getNbUniversesInCatalog(state)
  const product = getCurrentProduct(state)
  const typeOfAccess = getTypeOfAccess(state)

  return {
    '# of Sub Universes': getNbSubUniversesInCatalog(state),
    '# of Universes': nbUniverses > 1 ? nbUniverses : 0,
    'Access': MIXPANEL_ACCESS_MAP[getFrom(state)] || '',
    'Days Since Sale Start': getDaysSinceStartSale(state),
    ...getCurrentProductLabelsFormattedForTracking(state),
    'Lowest Price': getProductCallPrice(state),
    'Operation Code': getOperationCode(state),
    'Product': product.content.title,
    'Product ID': product.ecomm.externalId,
    'Product Price': getProductPriceValue(state),
    'Sale Start Time': getSaleStartTime(state),
    'Stock Status': product.outOfStock ? 'Not Available' : 'Available',
    'Type of access': typeOfAccess,
    'Under Universe': nbUniverses > 1 ? getCurrentResourceSubUniverseName(state) : '',
    'Universe': nbUniverses > 1 ? getCurrentResourceUniverseName(state) : ''
  }
}

export const getViewedProductsData = (state) => (getIsViewedProductsFetched(state)
  ? {
      '# of Recently Viewed Product Displayed': R.length(getFilteredViewedProducts(state)),
      'Cross Sell Display': getHasCrossSaleOnLastViewedProducts(state),
      'Cross-Sell Type': 'Recently Viewed Product'
    }
  : {})

const viewProductPageEpic = (actions$, state$) => actions$.pipe(
  disableMixPanelTracking(actions$),
  ofType(LOCATION_CHANGE),
  distinctUntilChanged(R.eqBy(R.path(['payload', 'location', 'pathname']))),
  filter(isProductPageAction),
  delayWhen(locationChangeAction => {
    const resourceFetched$ = actions$.pipe(ofType(Actions.resources.RESOURCE_FETCHED))
    const locationChangeKey = queryFromString(locationChangeAction.payload.location.search).key
    return (getIsSaleFetched(state$.value) && isProductFetched(locationChangeKey)(state$.value))
      ? of({})
      : awaitForProductFetched(locationChangeKey, resourceFetched$, state$)
  }),
  filter(locationChangeAction => isSamePage(locationChangeAction, state$.value)),
  map(locationChangeAction => ({
    action: locationChangeAction,
    data: getViewProductPageData(state$.value)
  })),
  // delayWhen(() => (getIsViewedProductsFetched(state$.value))
  //   ? of({})
  //   : merge(
  //     awaitForLastViewedProductsFetched(actions$, state$),
  //     awaitForPageChanged(actions$)
  //   )
  // ),
  tap(({ data }) => {
    track('View Product Page', { ...data, ...getViewedProductsData(state$.value) }, { debug: !__PRODUCTION__ })
  }),
  ignoreElements()
)

export default viewProductPageEpic
